import angular from "angular";

angular.element(document).ready(() => {
    angular.bootstrap(document, ["mmManagePortal"], {
        // strictDi: true,
    });
});
